import {LETTER, NIKUD, METEG, getLetterWithReversedDageshFromLetterArray, stringWithoutNikud} from './commonHebrew'
import {getStandardLetterArray, getChosenWordString} from '@/js/letterOperations'
import _ from 'lodash'
import {AppConfig} from '../appConfig';

const DAGESH = 'ּ'
const NEVER_ADD_DAGESH_LETTERS = ['א', 'ע', 'ח', 'ה', 'ר', 'ו']
const NEVER_REMOVE_DAGESH_LETTERS = ['ב', 'ג', 'ד', 'כ', 'פ', 'ת', 'ו']

function fixFirstLetterDagesh(letterArray, startWithDageshBcPrevEndedMa, prevStartedWithDageshBcPrevEndedMa) {
  const firstLetter = letterArray[0]
  if ((startWithDageshBcPrevEndedMa && !(firstLetter.includes(DAGESH))
        && !(NEVER_ADD_DAGESH_LETTERS.includes(firstLetter[0])))
      || (!startWithDageshBcPrevEndedMa && firstLetter.includes(DAGESH)
        && !(NEVER_REMOVE_DAGESH_LETTERS.includes[firstLetter[0]]))
        && prevStartedWithDageshBcPrevEndedMa) {
    letterArray[0] = getLetterWithReversedDageshFromLetterArray(letterArray, 0)
  }
}

function getStartingWithDageshChanges (wordObj, startWithDageshBcPrevEndedMa) {
  var changes = {}
  var newOptions = JSON.parse(JSON.stringify(wordObj.options))
  var changedOptions = false
  newOptions.forEach(option => {
    if (option.displayText !== stringWithoutNikud(option.displayText)) {
      var letterArray = getStandardLetterArray(option.displayText)
      const prevStartedWithDageshBcPrevEndedMa = option.startedWithDageshBcPrevEndedMa
      fixFirstLetterDagesh(letterArray, startWithDageshBcPrevEndedMa, prevStartedWithDageshBcPrevEndedMa)
      const newDisplayText = letterArray.join('')
      if (newDisplayText !== option.displayText) {
        // console.log('option.displayText (before changing):')
        // console.log(option.displayText)
        // console.log('newDisplayText:')
        // console.log(newDisplayText)
        option.displayText = newDisplayText
        // console.log('option.displayText (after changing):')
        // console.log(option.displayText)
        option['startedWithDageshBcPrevEndedMa'] = startWithDageshBcPrevEndedMa
        changedOptions = true
      }
    }
  })
  if (changedOptions) changes['options'] = newOptions
  if (wordObj.choiceType !== 'option') {
    const prevChosenWord = getChosenWordString(wordObj)
    var letterArray = getStandardLetterArray(prevChosenWord)
    const prevStartedWithDageshBcPrevEndedMa = wordObj.specialData[wordObj.choiceType + 'StartedWithDageshBcPrevEndedMa']
    fixFirstLetterDagesh(letterArray, startWithDageshBcPrevEndedMa, prevStartedWithDageshBcPrevEndedMa)
    const newChosenWord = letterArray.join('')
    if (prevChosenWord !== newChosenWord) {
      if (wordObj.choiceType === 'manual') {
        changes['manualNikud'] = newChosenWord
      } else changes['editedNikud'] = newChosenWord
      changes['specialData'] = JSON.parse(JSON.stringify(wordObj.specialData))
      changes.specialData[wordObj.choiceType + 'StartedWithDageshBcPrevEndedMa'] = startWithDageshBcPrevEndedMa
    }
  }
  if (Object.keys(changes).length) {
    if (!(wordObj.altered)) changes['altered'] = true
    return changes
  } else return null
}

const dageshAfterMah = {
  applyRule: function (step, relevantOptions, mainWordObj, otherWordObj, changesObjs) {
    if (!(relevantOptions.mahPatachDagesh)
        || relevantOptions.dageshOnlyIfHeard || step === 'letter-array-assignment') return
    var word1, word2, whichObjIsWord2
    if (step === 'word-mutating') {
      word1 = mainWordObj
      word2 = otherWordObj
      whichObjIsWord2 = 'otherWord'
    } else { // step === 'results-integrating'
      word1 = otherWordObj
      word2 = mainWordObj
      whichObjIsWord2 = 'mainWord'
    }
    // const chosenWord = getChosenWordString(word1)
    const startNextWordWithDagesh = word1.choiceType === 'option' && word1.options[word1.chosenOptionIndex].startNextWithDagesh
    // (now this part is "understood") ['מַה', 'מַּה'].some(form => chosenWord.endsWith(form))
    var startingWithDageshChanges = getStartingWithDageshChanges(word2, startNextWordWithDagesh)
    // console.log('startingWithDageshChanges:')
    // console.log(startingWithDageshChanges)
    if (startingWithDageshChanges) Object.assign(changesObjs[whichObjIsWord2], startingWithDageshChanges)
  }
}

/* (currently not used)
function getLatestOptionVariant(optionObj, optionIndex, changeObj, variantKey) {
  return changeObj.optionVariants && changeObj.optionVariants[variantKey] ?
    changeObj.optionVariants[variantKey][optionIndex]
    : (optionObj.displayVariants && optionObj.displayVariants[variantKey] ?
      optionObj.displayVariants[variantKey]
        : optionObj.displayText)
} */

const VOWELS_ARRAY = Object.values(NIKUD).filter(n => !([NIKUD.SIN_DOT, NIKUD.SHIN_DOT, NIKUD.DAGESH].includes(n)))
const NON_MALEH_NIKUD_ARRAY = Object.values(NIKUD).filter(n => !([NIKUD.HOLAM, NIKUD.DAGESH].includes(n)))
const PREMALEH_NIKUD_ARRAY = [NIKUD.HATAF_QAMATZ, NIKUD.QAMATZ, NIKUD.QAMATZ_QATAN]
const NON_PREMALEH_VOWELS_ARRAY = VOWELS_ARRAY.filter(v => !(PREMALEH_NIKUD_ARRAY.includes(v)))
const CHOLAM_VAV_AIM_REGEX = new RegExp(NIKUD.HOLAM + LETTER.VAV + METEG, 'g')
const CHOLAM_REGEX = new RegExp(NIKUD.HOLAM)
const EVERY_METEG_REGEX = new RegExp(METEG, 'g')
const EVERY_QUBUTZ_FOLLOWED_BY_NON_VAV_REGEX = new RegExp(NIKUD.QUBUTZ + '([^' + LETTER.VAV + '])', 'g')
const NONLETTERS_VOWEL_NONLETTERS_LETTER_CONTROL_GROUP = '([^' + Object.values(LETTER).join('') + ']*[' 
  + VOWELS_ARRAY.join('') + '][^' + Object.values(LETTER).join('') + ']*[' + Object.values(LETTER).join('') + '])'
const EVERY_QUBUTZ_VAV_WITH_NON_DAGESH_VOWEL_REGEX = new RegExp(NIKUD.QUBUTZ + LETTER.VAV
  + NONLETTERS_VOWEL_NONLETTERS_LETTER_CONTROL_GROUP, 'g')
const EVERY_QUBUTZ_VAV_REGEX = new RegExp(NIKUD.QUBUTZ + LETTER.VAV, 'g')
const EVERY_CHOLAM_VAV_NOT_FOLLOWED_BY_NON_MALEH_NIKUD_REGEX = new RegExp(NIKUD.HOLAM + LETTER.VAV 
                                                        + '(([^' + NON_MALEH_NIKUD_ARRAY.join('') + '])|$)', 'g')
const LETTER_WITH_NON_PREMALEH_VOWEL_OR_STRING_START_CONTROL_GROUP = 
  '(^|([' + Object.values(LETTER).join('') + '][^' + Object.values(LETTER).join('') + ']*[' 
    + NON_PREMALEH_VOWELS_ARRAY.join('') + '][^' + Object.values(LETTER).join('') +']*))'
const EVERY_LETTER_WITH_NONPMVOWEL_OR_SS_VAV_CHOLAM_REGEX = new RegExp(
  LETTER_WITH_NON_PREMALEH_VOWEL_OR_STRING_START_CONTROL_GROUP + LETTER.VAV + NIKUD.HOLAM, 'g')
const NON_VAV_LETTERS_ARRAY = Object.values(LETTER).filter(le => le !== LETTER.VAV)
const NON_YUD_LETTERS_ARRAY = Object.values(LETTER).filter(le => le !== LETTER.YUD)
const SILENT_LETTERS_ARRAY = [LETTER.YUD, LETTER.ALEF]
const NON_SILENT_LETTERS_ARRAY = Object.values(LETTER).filter(le => !(SILENT_LETTERS_ARRAY.includes(le)))
const EVERY_NON_VAV_LETTER_CHOLAM_REGEX = new RegExp('([' + NON_VAV_LETTERS_ARRAY.join('') + '])' + NIKUD.HOLAM, 'g')
const EVERY_KAMATZ_KATAN_FOLLOWED_BY_NONVAVLETTER_OR_VAVWITHNIKUD_REGEX = new RegExp(NIKUD.QAMATZ_QATAN
  + '(([' + NON_VAV_LETTERS_ARRAY.join('') + '])|(' + LETTER.VAV + '[' + Object.values(NIKUD).join('') + ']))', 'g')
const EVERY_KAMATZ_OR_KAMATZ_KATAN_FOLLOWED_BY_VAV_WITHOUT_NIKUD_REGEX = new RegExp('[' 
  + NIKUD.QAMATZ + NIKUD.QAMATZ_QATAN + ']' + LETTER.VAV + '([' + Object.values(LETTER).join('') + '])', 'g')
const NON_SILENT_LETTER_WITHOUT_VOWELS_CONTROL_GROUP = '([' + NON_SILENT_LETTERS_ARRAY.join('') 
  + '][^' + Object.values(LETTER).join('') + VOWELS_ARRAY.join('') + ']*)'
const SILENT_LETTER_WITHOUT_VOWELS_CONTROL_GROUP = '([' + SILENT_LETTERS_ARRAY.join('') 
  + '][^' + Object.values(LETTER).join('') + VOWELS_ARRAY.join('') + ']*)'
const NOT_FOLLOWED_BY_CHOLAM_OR_DAGESH_CONTROL_GROUP = '(([^' + NIKUD.HOLAM + NIKUD.DAGESH + '])|$)'
const EVERY_NON_SILENT_NON_VOWELED_LETTER_AND_VAV_NOT_FOLLOWED_BY_CHOLAM_OR_DAGESH_REGEX = new RegExp(
  NON_SILENT_LETTER_WITHOUT_VOWELS_CONTROL_GROUP + LETTER.VAV + NOT_FOLLOWED_BY_CHOLAM_OR_DAGESH_CONTROL_GROUP, 'g')
const EVERY_SILENT_NON_VOWELED_LETTER_AND_VAV_FOLLOWED_BY_NON_CHOLAM_OR_DAGESH_REGEX = new RegExp(
  SILENT_LETTER_WITHOUT_VOWELS_CONTROL_GROUP + LETTER.VAV + '([^' + NIKUD.HOLAM + NIKUD.DAGESH + '])')
const EVERY_CHIRIK_FOLLOWED_BY_NONYUDLETTER_OR_YUDWITHVOWEL_REGEX = new RegExp(NIKUD.HIRIQ + '(([' 
  + NON_YUD_LETTERS_ARRAY.join('') + '])|(' 
  + LETTER.YUD + '[^' + Object.values(LETTER).join('') + ']*[' + VOWELS_ARRAY.join('') +']))', 'g')

const ADDING_AIMS = AppConfig.IN_KETIV_MALEH_AUTO_ADD_AIMS

function getKetivMalehText(oldText) {
  if (oldText === stringWithoutNikud(oldText)) return oldText
  // KETIV MALEH RULE 1: no metegs
  var newText = oldText.replace(EVERY_METEG_REGEX, '')
  // KETIV MALEH RULE 2: after every qubutz a vav
  if (ADDING_AIMS) newText = newText.replace(EVERY_QUBUTZ_FOLLOWED_BY_NON_VAV_REGEX, NIKUD.QUBUTZ + LETTER.VAV + '$1')
  // KETIV MALEH RULE 3: every qubutz-vav with non-dagesh vowel => add additional vav
  if (ADDING_AIMS) newText = newText.replace(EVERY_QUBUTZ_VAV_WITH_NON_DAGESH_VOWEL_REGEX, NIKUD.QUBUTZ + LETTER.VAV + LETTER.VAV + '$1')
  // KETIV MALEH RULE 3: every qubutz-vav => vav-dagesh(shuruk)
  newText = newText.replace(EVERY_QUBUTZ_VAV_REGEX, LETTER.VAV + NIKUD.DAGESH)
  // console.log('newText after rule 3:' + newText)
  // console.log(newText)
  // KETIV MALEH RULE 4: cholam-vav not followed by nonmalehnikud => vav-cholam
  newText = newText.replace(EVERY_CHOLAM_VAV_NOT_FOLLOWED_BY_NON_MALEH_NIKUD_REGEX, LETTER.VAV + NIKUD.HOLAM + '$1')
  // console.log('newText after rule 4:' + newText)
  // console.log(newText)
  // KETIV MALEH RULE 5: letterwithnonpremalehvowelorstringstart-vav-cholam => add ANOTHER vav before the cholam
  if (ADDING_AIMS) newText = newText.replace(EVERY_LETTER_WITH_NONPMVOWEL_OR_SS_VAV_CHOLAM_REGEX, '$1' + LETTER.VAV + LETTER.VAV + NIKUD.HOLAM)
  // console.log('newText after rule 5:' + newText)
  // console.log(newText)
  // KETIV MALEH RULE 6: nonvavletter-cholam => add a vav before the cholam
  if (ADDING_AIMS) newText = newText.replace(EVERY_NON_VAV_LETTER_CHOLAM_REGEX, '$1' + LETTER.VAV + NIKUD.HOLAM)
  // console.log('newText after rule 6:' + newText)
  // console.log(newText)
  // KETIV MALEH RULE 7: kamatzkatan followed by (nonvavletter or vavwithnikud) => add vav after kamatzkatan
  if (ADDING_AIMS) newText = newText.replace(EVERY_KAMATZ_KATAN_FOLLOWED_BY_NONVAVLETTER_OR_VAVWITHNIKUD_REGEX, 
    NIKUD.QAMATZ_QATAN + LETTER.VAV + '$1')
  // console.log('newText after rule 7:' + newText)
  // console.log(newText)
  // KETIV MALEH RULE 8: kamatz or kamatzkatan followed by vav without nikud => remove kamatz/kamatzkatan
  newText = newText.replace(EVERY_KAMATZ_OR_KAMATZ_KATAN_FOLLOWED_BY_VAV_WITHOUT_NIKUD_REGEX, 
    LETTER.VAV + '$1')
  // console.log('newText after rule 8:' + newText)
  // console.log(newText)
  // KETIV MALEH RULE 9: nonsilentletterwithoutvowel-vav not followed by cholam or dagesh(shuruk) => add cholam
  newText = newText.replace(EVERY_NON_SILENT_NON_VOWELED_LETTER_AND_VAV_NOT_FOLLOWED_BY_CHOLAM_OR_DAGESH_REGEX,
    '$1' + LETTER.VAV + NIKUD.HOLAM + '$2')
  // console.log('newText after rule 9:' + newText)
  // console.log(newText)
  // KETIV MALEH RULE 10: nonsilentletterwithoutvowel-vav not followed by cholam or dagesh(shuruk) => add cholam
  newText = newText.replace(EVERY_SILENT_NON_VOWELED_LETTER_AND_VAV_FOLLOWED_BY_NON_CHOLAM_OR_DAGESH_REGEX,
    '$1' + LETTER.VAV + NIKUD.HOLAM + '$2')
  // console.log('newText after rule 10:' + newText)
  // console.log(newText)
  // KETIV MALEH RULE 11: chirik followed by nonyudletter or yud with vowel - add a yud in between
  if (ADDING_AIMS) newText = newText.replace(EVERY_CHIRIK_FOLLOWED_BY_NONYUDLETTER_OR_YUDWITHVOWEL_REGEX, 
    NIKUD.HIRIQ + LETTER.YUD + '$1')
  return newText
}

function getKetivMalehChanges (wordObj) {
  var changes = {}
  var newOptions = []
  var changedOptions = false
  wordObj.options.forEach(option => {
    const newOption = JSON.parse(JSON.stringify(option))
    newOption.displayText = getKetivMalehText(option.displayText)
    var sameStringOptions = newOptions.filter(o => o.displayText === newOption.displayText)
    if (sameStringOptions.length) {
      if (!(_.isEqual(sameStringOptions[0].morphArray, newOption.morphArray))) {
        newOption.morphArray.forEach(newMorph => {
          if (!(sameStringOptions[0].morphArray.some(alreadyMorph => _.isEqual(newMorph, alreadyMorph)))) {
            sameStringOptions[0].morphArray.push(newMorph)
          }
        })
      }
      changedOptions = true
    } else {
      newOptions.push(newOption)
      if (newOption.displayText !== option.displayText) changedOptions = true
    }
  })
  // console.log('newOptions:')
  // console.log(newOptions)
  if (changedOptions) changes['options'] = newOptions
  if (wordObj.choiceType !== 'option') {
    const prevChosenWord = getChosenWordString(wordObj)
    const newChosenWord = getKetivMalehText(prevChosenWord)
    if (prevChosenWord !== newChosenWord) {
      if (wordObj.choiceType === 'manual') {
        changes['manualNikud'] = newChosenWord
      } else changes['editedNikud'] = newChosenWord
    }
  }
  if (Object.keys(changes).length) {
    if (!(wordObj.altered)) changes['altered'] = true
    return changes
  } else return null
}

const ketivMaleh = {
  applyRule: function (step, relevantOptions, mainWordObj, changesObjs) {
    if (relevantOptions.ketivMaleh && ['word-mutating', 'results-integrating'].includes(step)) {
      var ketivMalehChanges = getKetivMalehChanges(mainWordObj)
      if (ketivMalehChanges) Object.assign(changesObjs.mainWord, ketivMalehChanges)
    } else if (step === 'letter-array-assignment') {
      // KETIV CHASEIR RULE 1: cholam before aim vav => when showing, shift cholam to vav
      // a) use rule to provide 'shiftNikudToNextRegExp' & 'nikudFromPreviousToAdd' props for 'standardLetterArray'
      //    (to serve as 'instructions' to the NikudResultsContainer)
      if (!(changesObjs.mainWord.hasOwnProperty('standardLetterArrayVariants'))) {
        changesObjs.mainWord['standardLetterArrayVariants'] = mainWordObj.standardLetterArray.map(() => { return {}})
      }
      mainWordObj.standardLetterArray.forEach((letterString, le) => {
        if (le > 0 && mainWordObj.standardLetterArray[le - 1].includes(NIKUD.HOLAM)
            && letterString.startsWith(LETTER.VAV + METEG)) {
          changesObjs.mainWord.standardLetterArrayVariants[le]['nikudFromPreviousToAdd'] = NIKUD.HOLAM
        } else if (le < mainWordObj.standardLetterArray.length - 1 && letterString.includes(NIKUD.HOLAM)
            && mainWordObj.standardLetterArray[le + 1].startsWith(LETTER.VAV + METEG)) {
          changesObjs.mainWord.standardLetterArrayVariants[le]['shiftNikudToNextRegExp'] = CHOLAM_REGEX
        }
      })
      // b) use rule to provide "replace()-args if showing aims" for each 'option' (used to be 'displayIfShowingAims')
      //    (assumes all rules to be applied thus can be applied one after the other)
      if (!(changesObjs.mainWord.hasOwnProperty('optionVariants'))) changesObjs.mainWord['optionVariants'] = {}
      changesObjs.mainWord.optionVariants['replaceArgsIfShowingAims'] = mainWordObj.options.map(() => {
        return [CHOLAM_VAV_AIM_REGEX, LETTER.VAV + METEG + NIKUD.HOLAM]
      })
    }
  }
}

const rulesInvolvingTwoWordsInARow = [dageshAfterMah]
const rulesInvolvingOneWords = [ketivMaleh]

export function applySpecialNikud (stateForOptions, step, mainWordObj, otherWordObj=null) { // if the word before/after's needed
                                  // if step = 'word-mutating' - otherword = 2nd, if 'results-integrating' => 1st
  const relevantOptions = { // "optionsObj" (should ony be used here, so the rest of the code will be "self-contained"
    ketivMaleh: stateForOptions.preSubmissionOptions.ketivMaleh,
    dageshOnlyIfHeard: stateForOptions.preSubmissionOptions.dageshOnlyIfHeard,
    mahPatachDagesh: stateForOptions.preSubmissionOptions.mahPatachDagesh
  }
  var changesObjs = { mainWord: {}, otherWord: {} }
  rulesInvolvingOneWords.forEach(nikudRule => {
    nikudRule.applyRule(step, relevantOptions, mainWordObj, changesObjs)
  })
  if (otherWordObj) rulesInvolvingTwoWordsInARow.forEach(nikudRule => {
    nikudRule.applyRule(step, relevantOptions, mainWordObj, otherWordObj, changesObjs)
  })
  return changesObjs
}

export function processSpecialNikudDisplayProps (wordsArray, keepingAims, metegMode = 'no-metegs') {
  return wordsArray.map((word) => {
    const shiftingNikud = (keepingAims || metegMode === 'keep-metegs') && word.displayVariants
    const postNikudShifting = word.standardLetterArray.map((letterString, le) => {
      return (shiftingNikud && word.displayVariants[le].shiftNikudToNextRegExp 
          ? letterString.replace(word.displayVariants[le].shiftNikudToNextRegExp, '') : letterString)
      + (shiftingNikud && word.displayVariants[le].nikudFromPreviousToAdd 
          ? word.displayVariants[le].nikudFromPreviousToAdd : '')
    }).join('')
    const postAimHandling = metegMode === 'keep-metegs' ? postNikudShifting
      : postNikudShifting.replace(/([אהוי])ֽ/g, keepingAims ? '$1' : '')
    return word.sepBefore + postAimHandling + word.sepAfter
  }).join('')
}
